module.exports = __webpack_public_path__ + "img/avatar5.0c20d52f.png";